import { render, staticRenderFns } from "./BrandColorPicker.vue?vue&type=template&id=ac25ce94&"
import script from "./BrandColorPicker.vue?vue&type=script&lang=ts&"
export * from "./BrandColorPicker.vue?vue&type=script&lang=ts&"
import style0 from "./BrandColorPicker.vue?vue&type=style&index=0&id=ac25ce94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports